import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-LM-logo_svg__Layer_2",
  "data-name": "Layer 2",
  viewBox: "0 0 174.5 157.8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-LM-logo_svg__cls-1{fill:#da291c}.svg-LM-logo_svg__cls-2{fill:#333}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("g", {
      id: "svg-LM-logo_svg__Layer_1-2",
      "data-name": "Layer 1-2"
    }, [
      _createElementVNode("path", {
        d: "M174 157.7v-15.5H78.6c-34.9 0-63.2-28.3-63.2-63.2V0H0v78.9c-.1 43.48 35.06 78.8 78.54 78.9h.26l95.2-.1Z",
        class: "svg-LM-logo_svg__cls-1"
      }),
      _createElementVNode("path", {
        d: "M78.7 130.5c-28.43-.09-51.42-23.17-51.4-51.6V0h15.8v78.9c0 19.62 15.88 35.55 35.5 35.6h.1l95.2-.1v16.1H78.7Z",
        class: "svg-LM-logo_svg__cls-1"
      }),
      _createElementVNode("path", {
        d: "M45.4 0h24.9l104.2 90.1V112L45.4 0zM89.1 0H114l60.5 51.8v22L89.1 0zM132.9 0h24.9l16.7 13.9v22L132.9 0z",
        class: "svg-LM-logo_svg__cls-2"
      })
    ], -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "LM-logo"}) } }